import { contrastRatio } from './colorContrast.js';
/** Below this ratio against its background, a button gets a border so it reads as one. */
const MIN_CONTRAST_THRESHOLD = 3.0;
/** False for an invalid color: no border is the safe default. */
export function buttonNeedsBorder(buttonFillHex, backgroundHex) {
    const ratio = contrastRatio(buttonFillHex, backgroundHex);
    if (ratio === null)
        return false;
    return ratio < MIN_CONTRAST_THRESHOLD;
}
/** `1px solid <text color>` when the fill would otherwise vanish into the page, else `none`. */
export function computeCtaBorder(buttonFillHex, buttonTextHex, backgroundHex) {
    if (buttonNeedsBorder(buttonFillHex, backgroundHex)) {
        return `1px solid ${buttonTextHex}`;
    }
    return 'none';
}
